import React, { useEffect } from 'react';
import './selects.css';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

const SelectBarrio = (props) => {
    useEffect(() => {
    }, []);
    return (
        <>
            {props.barrios && props.barrios.length > 0 ? <FormControl fullWidth>
                <InputLabel id="select-barrio">Barrio</InputLabel>
                <Select
                    className={props.error ? "w3-border w3-border-red" : "w3"}
                    size="small"
                    labelId="select-barrio"
                    id="select-barrio"
                    value={props.value}
                    label="barrio"
                    onChange={props.onChange}
                >
                    {props.barrios.map(barrio => <MenuItem key={barrio.IDBARRIO} value={barrio.IDBARRIO}>{decodeURIComponent(barrio.BARRIO)}</MenuItem>)}
                </Select>
            </FormControl> : null}
        </>
    );
}
export default SelectBarrio;